import type { Seg } from '@/engine/math';
import { tracePolygon, visibility, type VisResult } from './lighting';

/** A physical flash must obey both the blast's blockers and the viewer's sight. */
export function drawBlast(
  ctx: CanvasRenderingContext2D, effect: { x: number; y: number; t: number; dur: number },
  segs: Seg[], viewer: VisResult | null | undefined, camX: number, camY: number,
): void {
  if (viewer === null) return;
  const k = effect.t / effect.dur, radius = 6 + 30 * k;
  ctx.save();
  if (viewer) { tracePolygon(ctx, viewer, camX, camY); ctx.clip(); }
  tracePolygon(ctx, visibility(effect.x, effect.y, radius + 1, segs), camX, camY);
  ctx.clip();
  ctx.fillStyle = `rgba(255,241,168,${0.8 * (1 - k)})`;
  ctx.beginPath();
  ctx.arc(effect.x - camX, effect.y - camY, radius, 0, Math.PI * 2);
  ctx.fill();
  ctx.restore();
}
